import { useNavigate } from "react-router-dom";
import {LogOut, Settings} from "lucide-react";
import { DropdownMenu, 
    DropdownMenuContent, 
    DropdownMenuGroup, 
    DropdownMenuItem, 
    DropdownMenuLabel,
    DropdownMenuSeparator, 
    DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { UserData } from "modules/authentication/types/user-data";
import { endPointLogout } from "modules/main/services/endpoints";
import React, { useContext } from "react";
import { AuthContext } from "modules/authentication/context/auth-provider";
// import { userData } from "./types/user-types";



const getUserData = (): UserData => {
    try {
        const data = localStorage.getItem("userData");
        if (!data) return {} as UserData;
        
        const parsed = JSON.parse(data) as UserData;
        return parsed;
    } catch (error) {
        console.warn("Error parsing userData from localStorage:", error);
        return {} as UserData;
    }
};

export const AvatarOptions:React.FC<{isMobile?:boolean}> = ({isMobile}) => {
    const userData = getUserData();
    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout(); 
    }

    return (
        (isMobile)?
            <AvatarOptionsMobile userData={userData} logOutCallback={handleLogout}/>:
            <AvatarOptionsDesktop userData={userData} logOutCallback={handleLogout}/>
    );
}

const AvatarOptionsMobile:React.FC<{userData:UserData,logOutCallback:()=>void}>  = ({userData}) => {
    const getInitials = () => {
        const firstName = userData.first_name || '';
        const lastName = userData.last_name || '';
        return `${firstName[0] || 'U'}${lastName[0] || 'S'}`.toUpperCase();
    };

    const getFullName = () => {
        const firstName = userData.first_name || 'Usuario';
        const lastName = userData.last_name || '';
        return `${firstName} ${lastName}`;
    };

    return (
    <>
        <div className="flex w-full gap-2 items-center">
            <Avatar className="h-12  w-12 md:h-8 md:w-8">
                <AvatarImage src={userData.avatar_url} alt={getInitials()}/>
                <AvatarFallback>{getInitials()}</AvatarFallback>
            </Avatar>
            <span className="font-semibold">{getFullName()}</span>
        </div>    
    </>
    );
}

const AvatarOptionsDesktop:React.FC<{userData:UserData,logOutCallback:()=>void}> = ({userData, logOutCallback}) => {
    const navigate = useNavigate();
    
    const getInitials = () => {
        const firstName = userData.first_name || '';
        const lastName = userData.last_name || '';
        return `${firstName[0] || 'U'}${lastName[0] || 'S'}`.toUpperCase();
    };

    const getFullName = () => {
        const firstName = userData.first_name || 'Usuario';
        const lastName = userData.last_name || '';
        return `${firstName} ${lastName}`;
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="relative p-0">
                    <div className="flex w-full gap-2 items-center">
                        <Avatar className="h-7 w-7 md:h-8 md:w-8">
                            <AvatarImage src={userData.avatar_url} alt={getInitials()}/>
                            <AvatarFallback className="text-xs">{getInitials()}</AvatarFallback>
                        </Avatar>                     
                    </div>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="end" forceMount>
                <DropdownMenuLabel className="font-normal">
                    <div className="flex flex-col space-y-1">
                        <p className="text-sm font-medium leading-none">{getFullName()}</p>
                        <p className="text-xs leading-none text-muted-foreground">{userData.username || 'Sin email'}</p>
                    </div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuGroup>
                    {/* <DropdownMenuItem onSelect={()=>{navigate("")}}>                                        
                        <div className="flex gap-2"><Bell className="w-4 h-4"/>Notificaciones</div>                                     
                    </DropdownMenuItem>                      */}
                    <DropdownMenuItem onSelect={()=>{navigate("/settings")}}>                                        
                        <div className="flex w-full gap-2"><Settings className="w-4 h-4"/>Cuenta</div>                                        
                    </DropdownMenuItem>    
                    <DropdownMenuSeparator />
                    <DropdownMenuItem onSelect={()=>{logOutCallback()}}>
                        <LogOut className="w-4 h-4"/>Salir
                    </DropdownMenuItem>                                
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>      
    );
}
